export default "__VITE_ASSET__BaT7unlA__";